import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { planListViewed } from "@/lib/mixpanels/mixpanel";
import { Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { SubjectsWithString } from "src/api/product";
import { usePlansQuery } from "./hooks/usePlansQuery";
import UpsellingCard from "./UpsellingCard";
import { getTimerText } from "./utils/timerUtils";
/**
 * URL 기반 Position 생성 (예: '/passes/teacher?subject=EN' → '이용권 구매 페이지(선생님) - 영어 탭')
 */ const getPositionFromRoute = (pathname, subject)=>{
    const userType = pathname.includes("teacher") ? "선생님" : pathname.includes("student") ? "학생" : "";
    const subjectCode = Array.isArray(subject) ? subject[0] : subject;
    const subjectName = subjectCode && SubjectsWithString[subjectCode] || "";
    return "이용권 구매 페이지(".concat(userType, ")").concat(subjectName ? " - ".concat(subjectName, " 탭") : "");
};
const UpsellingSection = (param)=>{
    let { isLoggedIn  } = param;
    const router = useRouter();
    const { data  } = usePlansQuery(isLoggedIn);
    // mx-390: Plan List Viewed
    useEffect(()=>{
        if ((data === null || data === void 0 ? void 0 : data.plans) && data.plans.length > 0) {
            planListViewed({
                "Plan Ids": data.plans.map((p)=>p.id),
                "Plan Titles": data.plans.map((p)=>p.title),
                "Plan SubTitles": data.plans.map((p)=>p.body || null),
                "Accent Badge Names": data.plans.map((p)=>p.accentTagText || null),
                "Basic Badge Names": data.plans.map((p)=>p.basicTagText || null),
                "Timer Texts": data.plans.map((p)=>{
                    if (!p.useTimer || !p.expiredAt) return null;
                    return getTimerText(p.expiredAt);
                }),
                Images: data.plans.map((p)=>p.planPromotionImageUrl || ""),
                "Total Plan Count": data.plans.length,
                Position: getPositionFromRoute(router.pathname, router.query.subject)
            });
        }
    }, [
        data === null || data === void 0 ? void 0 : data.plans,
        router.pathname,
        router.query.subject
    ]);
    if (!isLoggedIn || !(data === null || data === void 0 ? void 0 : data.plans.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-auto flex w-full max-w-[840px] flex-col gap-12 max-md:px-8 max-sm:h-full max-sm:gap-10 max-sm:px-5",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full flex-col gap-5",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    className: "text-[#1c1f2e]",
                    children: "내 업그레이드 혜택"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "max-md:scrollbar-hide flex flex-col gap-5 max-md:-mx-5 max-md:flex-row max-md:overflow-x-auto max-md:px-5",
                    children: data.plans.map((plan, index)=>/*#__PURE__*/ _jsx(UpsellingCard, {
                            plan: plan,
                            planOrder: index + 1
                        }, plan.id))
                })
            ]
        })
    });
};
export default UpsellingSection;
